export default function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}


//////////////////
// WEBPACK FOOTER
// ../~/uncontrollable/~/@babel/runtime/helpers/esm/setPrototypeOf.js
// module id = 3195
// module chunks = 121